import { render, staticRenderFns } from "./WebhookRules.vue?vue&type=template&id=7197f85a&scoped=true"
import script from "./WebhookRules.vue?vue&type=script&lang=js"
export * from "./WebhookRules.vue?vue&type=script&lang=js"
import style0 from "./WebhookRules.vue?vue&type=style&index=0&id=7197f85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7197f85a",
  null
  
)

export default component.exports